var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"illustration",staticClass:"plugin-illustration",style:({ backgroundImage: _vm.backgroundImage, paddingTop: `${_vm.heightFactor}%` })})
}
var staticRenderFns = []

export { render, staticRenderFns }